import { citySchema } from "@/schemas/city-schema";
import { IFetchMarineStationResult } from "@/types/marine-station-type";

export const fetchMarineStation =
	async (): Promise<IFetchMarineStationResult> => {
		try {
			const res = await fetch(
				"https://kuwait.exelys.io/kuwait_marine_forecast/kuwait_harborsV2.geojson",
			);

			if (!res.ok) {
				throw new Error("Une erreur est survenue");
			}

			const data = await res.json();

			const validatedData = citySchema.parse(data);

			const { features } = validatedData;

			return {
				error: null,
				marineStation: features.map((item) => {
					return item;
				}),
				isLoading: false,
			};
		} catch {
			return {
				error: "Une erreur est survenue",
				marineStation: [],
				isLoading: false,
			};
		}
	};
